
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class ModellingViewGrid extends Serenity.EntityGrid<ModellingViewRow, any> {
        protected getColumnsKey() { return 'Rebalancer.ModellingView'; }
        protected getDialogType() { return ModellingViewDialog; }
        protected getIdProperty() { return ModellingViewRow.idProperty; }
        protected getLocalTextPrefix() { return ModellingViewRow.localTextPrefix; }
        protected getService() { return ModellingViewService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}